import * as React from "react";
import {
  ColumnDef,
  createColumnHelper,
  HeaderContext
} from "@tanstack/react-table";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { SelectableCustomer } from "src/pages/Admin/CustomersAndUsers/Customer/Users/UserCustomers/UserAssignedCustomerTab";

export interface IUserAssignableCustomersTableColumn {
  checkboxAction: (data: SelectableCustomer) => void
  bulkActionButton: (info: HeaderContext<SelectableCustomer, unknown>) => React.ReactNode,
  terminology: ITerminology
  columns?: UserCustomersColumnsPicked[]
}

type UserCustomersColumnsPicked = keyof AvailableCustomerUserCustomerTableColumns;

interface AvailableCustomerUserCustomerTableColumns{
  accountNumber: ColumnDef<SelectableCustomer, undefined>;
  name: ColumnDef<SelectableCustomer, undefined>;
  bulkActionCheck: ColumnDef<SelectableCustomer, undefined>;
}
/**
 * takes in a bulk action button and check box on change handler
 * returns columns that show a checkbox, branch number, branch name and branch type.
 */
export const getUserAssignableCustomersTableColumns = (params: IUserAssignableCustomersTableColumn) => {
  const customCustomerColumnHelper = customCreateColumnHelper<SelectableCustomer>();
  const customerColumnHelper = createColumnHelper<SelectableCustomer>();

  const AllColumns: AvailableCustomerUserCustomerTableColumns = {
    bulkActionCheck: customCustomerColumnHelper.checkboxColumn(customerColumnHelper, {
      enableColumnFilter: false,
      enableSorting: false
    }, "selected", params.checkboxAction, params.bulkActionButton),
    accountNumber: customCustomerColumnHelper.standardTextColumn(customerColumnHelper, "accountNumber", {
      header: "Account Number",
      size: 200
    }),
    name: customCustomerColumnHelper.standardTextColumn(customerColumnHelper, "name", { header: "name" })

  };

  if (params.columns) {
    return params.columns.map(column => AllColumns[ column ]);
  } else {
    return Object.values(AllColumns);
  }
};
